export class ClienteTag {
  public id: number;
  public client_id_app: number;
  public descricao: string;

  constructor() { }
}
